import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import _ from 'lodash'
import { Button } from '@shopify/polaris'

import IconPlus from 'templates/outSide/assets/img/icon-plus.png'
import { customCSSEffectToStringSimple } from 'utils/serializerCSS'
import { SHOPIFY_GRAY, fontSize, PURPLE } from 'components/styles'

const Wrapper = styled.div`
  height: 25.6em;
  width: 14.4em;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: ${SHOPIFY_GRAY};
  border: ${props => props.active ? `3px ${PURPLE}` : '2px gray'} solid;
  border-radius: 2px;
  cursor: pointer;
  margin-right: 2em;
  margin-bottom: 2em;
  position: relative;
`
const Container = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  font-size: 0.256em;
`
const ProductLinkContainer = styled.div`
  padding: 3em;
  color: #fff;
  font-family: 'Futura PT Heavy', sans-serif;
  position: absolute;
  text-decoration: none;
  text-transform: uppercase;
  transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1);
  top: calc(50% - 3em);
  cursor: pointer;
  -webkit-transform-style: preserve-3d;
  -webkit-transform: translate3d(0,0,0);

  left: ${props => props.x}em;
  transform: translate(0, ${props => props.y}em);

  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 1;
  ${props => props.styleRaw}
`
const Icon = styled.i`
  background-image: url(${IconPlus});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 4em;
  width: 3.75em;
  display: inline-block;
  left: 1em;
  margin-right: 2em;
  top: calc(-10% + 3.75em);
  opacity: 1;
`
const Title = styled.span`
  display: inline-block;
  opacity: 0;
  transform: translate3d(4em, 0, 0);
  flex: 1;
  text-align: left;
  font-size: 2.75em;

  opacity: 1;
  transform: translate3d(0, 0, 0);
`
const Logo = styled.div`
  background: center / contain no-repeat;
  background-image: url(${props => props.imageUrl});
  position: absolute;
  top: 3em;
  left: 3em;
  width: 7em;
  height: 7em;

  z-index: 100;
`
const ButtonsContainer = styled.div`
  ${fontSize}
  position: absolute;
  bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  left: 1em;
  right: 1em;
  & > button {
    font-size: 0.8em;
  }
`


class ProductSceneCard extends Component {

  renderProductLinks = () => {
    const { showcase, customizedSettings } = this.props
    if (showcase.products && showcase.products[0]) {
      return _.map(showcase.products, (product, idx) => {
          const customStyleName = `ou_showcase_link_p${showcase.slideId}_${idx}`
          const customStyle = _.get(customizedSettings, ['customStyles', customStyleName])
          const styleRaw = customCSSEffectToStringSimple(customStyle)
          return (
            <ProductLinkContainer x={product.x} y={product.y} key={product.id} styleRaw={styleRaw} >
              <Icon />
              <Title>{product.title}</Title>
            </ProductLinkContainer>
          )
        }
      )
    }
  }

  renderLogo = () => {
    const { showcase, customizedSettings } = this.props
    let image = customizedSettings.splash.logo
    if (showcase.logo) image = showcase.logo
    return (
      <Logo
        imageUrl={image}
      />
    )
  }

  editScene = (e) => {
    e.stopPropagation()
    const { startProductsSlideWizard, idx } = this.props
    startProductsSlideWizard(idx)
    // console.log('editScene', e)

  }

  deleteScene = (e) => {
    e.stopPropagation()
    const { deleteScene, idx } = this.props
    // console.log('deleteScene', idx)
    deleteScene(idx)
  }

  renderButtons = () => {
    return (
      <ButtonsContainer>
        <Button size='slim' primary onClick={this.editScene}>Edit</Button>
        <Button size='slim' destructive onClick={this.deleteScene}>Delete</Button>
      </ButtonsContainer>
    )
  }

  render () {
    const { onClick, showcase, idx, active } = this.props
    return (
      <Wrapper onClick={onClick} key={idx} active={active}>
        <Container>
          <div className='ou_showcase__image-container'>
            <div
              id={`ou_showcase__image${idx}`}
              style={{backgroundImage: `url(${showcase.image})`}}
              className={`ou_showcase__image ou_showcase_${idx}_image ou_showcase_${idx}_image_p js-scroll-x`}
            />
          </div>
          {this.renderProductLinks()}
          {this.renderLogo()}
          {this.renderButtons()}
        </Container>
      </Wrapper>
    )
  }
}


ProductSceneCard.propTypes = {
  deleteScene: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  showcase: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  customizedSettings: PropTypes.object.isRequired,
  active: PropTypes.bool.isRequired,
  startProductsSlideWizard: PropTypes.func.isRequired
}

export default connect()(ProductSceneCard)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/ShopifyScenesDashboard/ProductSceneCard.js